export const constant = {
    GET_SYSTEM_CONFIG_IN_PROGRESS: "GET_SYSTEM_CONFIG_IN_PROGRESS",
    GET_SYSTEM_CONFIG_COMPLETE: "GET_SYSTEM_CONFIG_COMPLETE"
  };